import { reactive } from 'vue';
import type { SwToPageMessage } from '../push/swMessages';

export const notificationFeed = reactive({
  items: [] as SwToPageMessage[],
});

let listening = false;

export function listenForPushMessages(): void {
  if (listening || !('serviceWorker' in navigator)) {
    return;
  }
  listening = true;
  navigator.serviceWorker.addEventListener('message', (event: MessageEvent<SwToPageMessage>) => {
    if (event.data?.type === 'push') {
      notificationFeed.items.unshift(event.data);
    }
  });
}
